/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type OnedriveData = {
  driveId: string;
  folderId: string;
  folderName: string;
};

/** @internal */
export const OnedriveData$inboundSchema: z.ZodType<
  OnedriveData,
  z.ZodTypeDef,
  unknown
> = z.object({
  drive_id: z.string(),
  folder_id: z.string(),
  folder_name: z.string(),
}).transform((v) => {
  return remap$(v, {
    "drive_id": "driveId",
    "folder_id": "folderId",
    "folder_name": "folderName",
  });
});
/** @internal */
export type OnedriveData$Outbound = {
  drive_id: string;
  folder_id: string;
  folder_name: string;
};

/** @internal */
export const OnedriveData$outboundSchema: z.ZodType<
  OnedriveData$Outbound,
  z.ZodTypeDef,
  OnedriveData
> = z.object({
  driveId: z.string(),
  folderId: z.string(),
  folderName: z.string(),
}).transform((v) => {
  return remap$(v, {
    driveId: "drive_id",
    folderId: "folder_id",
    folderName: "folder_name",
  });
});

export function onedriveDataToJSON(onedriveData: OnedriveData): string {
  return JSON.stringify(OnedriveData$outboundSchema.parse(onedriveData));
}
export function onedriveDataFromJSON(
  jsonString: string,
): SafeParseResult<OnedriveData, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => OnedriveData$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'OnedriveData' from JSON`,
  );
}
